import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import ProductSizeSelect from "../../../presentational/common/ProductSizeSelect";
import { clearSizeSelectError } from "../../../../state/modules/savedItems/actions";
import { getHasSizeSelectError } from "../../../../state/modules/savedItems/selectors";

const ProductSizeSelectContainer = ({ id, onChange, ...rest }) => {
  const dispatch = useDispatch();
  const hasError = useSelector(state => getHasSizeSelectError(state, { id }));

  const onChangeHandler = selectionEvent => {
    dispatch(clearSizeSelectError());
    onChange(selectionEvent);
  };

  return (
    <ProductSizeSelect
      {...{
        ...rest,
        onChange: onChangeHandler,
        hasError
      }}
    />
  );
};

ProductSizeSelectContainer.propTypes = {
  id: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

export default ProductSizeSelectContainer;
